/**

Coded by www.techhighway.ca

*/

import { useContext, useEffect, useState } from "react";

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import UserAvatar from "utility/user-avatar";

import AuthService from "services/auth-service";
import "./styles.css";
// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
  navbarRow,
} from "components/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  AuthContext,
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "context";

function DashboardNavbar({ absolute, light, isMini, breadcrumbsTitle }) {
  const authContext = useContext(AuthContext);
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;

  const name = `${authContext.userDetail.first_name} ${authContext.userDetail.last_name}`;

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const [marginLeft, setMarginLeft] = useState(66); // Initial margin
  const handleMiniSidenav = () => {
    if (miniSidenav) {
      // mini menu
      setMarginLeft((prev) => prev + 180);
    } else {
      // expanded menu
      setMarginLeft((prev) => prev - 180);
    }
    setMiniSidenav(dispatch, !miniSidenav);
  };

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : white.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  const handleLogOut = async () => {
    const response = await AuthService.logout();
    authContext.logout();
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      className="gradient-45deg-indigo-purple"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <MDBox className="content-wrapper-before gradient-45deg-indigo-purple" />
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {isMini ? null : (
          <>
            <MDBox className="menu">
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
                style={{ marginLeft: `${marginLeft}px`, transition: "margin-left 0.3s ease" }}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
            </MDBox>
            <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
              {/* <MDBox pr={1}>
                <MDInput label="Search here" />
              </MDBox> */}
              <MDBox
                display="flex"
                textAlign="right"
                alignItems="center"
                color={light ? "white" : "inherit"}
                width="100%"
              >
                <MDBox display="flex" justifyContent="flex-end" width="100%" alignItems="center">
                  <Link to="/user-profile">
                    <IconButton sx={navbarIconButton} size="small" disableRipple title={name}>
                      <UserAvatar name={name} size="sm" shadow="sm" />
                      {/* <MDAvatar
                        src={defaultUserImage(name)}
                        alt="profile-image"
                        size="sm"
                        shadow="sm"
                      /> */}
                    </IconButton>
                  </Link>
                  <MDBox>
                    <MDTypography
                      ml={1}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "10px",
                      }}
                      component={Link}
                      onClick={handleLogOut}
                      to=""
                      title="LOG OUT"
                      display="block"
                      variant="caption"
                      color="white"
                      fontWeight="bold"
                    >
                      <Icon fontSize="small">logout_icon</Icon>
                      <p>LOG OUT</p>
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  breadcrumbsTitle: PropTypes.string,
};

export default DashboardNavbar;
